import { useEffect } from "react";

export default function TermedWidget() {
    useEffect(() => {
        // entferne vorheriges Script, falls es existiert
        const existing = document.getElementById("termed-script");
        if (existing) {
            existing.remove();
        }

        // div leeren, damit das Widget nicht doppelt gerendert wird
        const container = document.getElementById("ivg9d");
        if (container) {
            container.innerHTML = "";
        }

        // neues Script einfügen
        const script = document.createElement("script");
        script.id = "termed-script";
        script.src =
            "https://api.termed.de/v2/facharzt_widget.php?id=ivg9d&w=5298b3a69a";
        script.type = "text/javascript";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            // Cleanup beim Verlassen der Seite
            script.remove();
            if (container) container.innerHTML = "";
        };
    }, []);

    return <div id="ivg9d" className="max-w-4xl"></div>;
}
